export default {
    pagesRecommends: [],
    rolesRecommends: [],
}